import Envelope from "./envelope"
import Facebook from "./facebook"
import Instagram from "./instagram"
import Eye from "./eye"
import EyeSlash from "./eyeslash"
import Phone from "./phone"

export { Eye, EyeSlash, Envelope, Facebook, Instagram, Phone }
